import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { MechanicService } from '../../../business-services/mechanic.service';

const MechanicEditTabs: { id: number, label: string, route: string }[] = [
  { id: 1, label: 'lblDetails', route: 'basic' },
  { id: 2, label: 'lblCompetence/Skills', route: 'competence' },
  { id: 3, label: 'lblShiftTimings', route: 'hours' },
  { id: 6, label: 'lblCustomerWaiting', route: 'customer-waiting-hours' },
  { id: 4, label: 'lblLeaves', route: 'leaves' },
  { id: 5, label: 'lblMechanicReceipentList', route: 'recipent-list'}
]


@Component({
  selector: 'app-edit-mechanic',
  templateUrl: './edit-mechanic.component.html'
})



export class EditMechanicComponent implements OnInit, OnDestroy{
  id:number;
  dealerId: string;
  selectedtab:number=1;
  tabs: { id: number, label: string, route: string }[] = MechanicEditTabs;
  mechanicName:string;
  isConsiderCustomerWaitingSlots:boolean | null;
  private customerWaitingSubscription = new Subscription();
  constructor(private secureStorage: SecureStorage,
    private mechanicService: MechanicService,private activeModal : NgbActiveModal) 
    {}

    ngOnInit(): void {
      this.mechanicService.isEdit = true;
      this.id = this.mechanicService.mechanicId;
      this.mechanicName = this.mechanicService.mechanicName;
      this.dealerId = this.mechanicService.dealerId;
      this.customerWaitingSubscription = this.mechanicService.isConsiderCustomerWaitingSlots$.subscribe(value => {
        this.isConsiderCustomerWaitingSlots = value;
        this.tabs = value === false
          ? MechanicEditTabs
          : MechanicEditTabs.filter(tab => tab.route !== 'customer-waiting-hours');
      });
    }

    ngOnDestroy(): void {
      this.mechanicService.mechanicId = null;
      this.customerWaitingSubscription?.unsubscribe();
      this.mechanicService.isConsiderCustomerWaitingSlots$.next(null);
    }
   
    OnClose(){
      this.activeModal.close({ success: true });
    }

}
